import mitt from "mitt";
const emitter = mitt();
export function useMagicEmitter() {
  return {
    on: emitter.on,
    off: emitter.off,
    emit: emitter.emit
  };
}
